import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/customers/actions';
import { CustomerInvitationsActionTypes } from '@appStore/customers/actions/customer-invitations.actions';
import { CustomerService } from '@appStore/customers/services';

@Injectable()
export class CustomerInvitationsEffects {
  constructor(private customerService: CustomerService, private actions$: Actions, private router: Router) {}

  createCustomerInvitation$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.BulkCreateCustomerInvitations),
      map((action: actions.BulkCreateCustomerInvitations) => action.payload),
      exhaustMap(invitations =>
        this.customerService.bulkCreateCustomerInvitations(invitations).pipe(
          map(items => new actions.BulkCreateCustomerInvitationsSuccess(items)),
          catchError(error => of(new actions.BulkCreateCustomerInvitationsFail(error)))
        )
      )
    );
  });

  createCustomersInvitation$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.BulkCreateCustomersInvitations),
      map((action: actions.BulkCreateCustomersInvitations) => action.payload),
      exhaustMap(invitations =>
        this.customerService.bulkCreateCustomersInvitations(invitations).pipe(
          map(items => new actions.BulkCreateCustomersInvitationsSuccess(items)),
          catchError(error => of(new actions.BulkCreateCustomersInvitationsFail(error)))
        )
      )
    );
  });

  /*
  loadCustomersInvitations$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.CustomerInvitationsLoadData),
      exhaustMap((action: CustomerInvitationsLoadData) => {
        return this.customerService.getCustomerInvitations(action.payload).pipe(
          map(invitations => new actions.CustomerInvitationsLoadSuccess(invitations)),
          catchError(error => of(new actions.CustomerInvitationsLoadFail(error)))
        );
      })
    );
  });
*/

  removeCustomerInvitation$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.CustomerInvitationRemove),
      map((action: actions.CustomerInvitationRemove) => action.payload),
      exhaustMap(invitation =>
        this.customerService.removeCustomerInvitation(invitation).pipe(
          map(() => new actions.CustomerInvitationRemoveSuccess(invitation)),
          catchError(error => of(new actions.CustomerInvitationRemoveFail(error)))
        )
      )
    );
  });
 
  sendCustomerInvitation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.CustomerInvitationSend),
      map((action: actions.CustomerInvitationSend) => action.payload),
      exhaustMap(invitation =>
        this.customerService.sendCustomerInvitation(invitation).pipe(
          map(item => new actions.CustomerInvitationSendSuccess(item)),
          catchError(error => of(new actions.CustomerInvitationSendFail(error)))
        )
      )
    );
  });
 

  loadMyCustomersInvitations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerInvitationsActionTypes.CustomersInvitationsLoadData),
      exhaustMap(action => {
        return this.customerService.getMyCustomersInvitations().pipe(
          map(invitations => new actions.CustomersInvitationsLoadSuccess(invitations)),
          catchError(error => of(new actions.CustomersInvitationsLoadFail(error)))
        );
      })
    );
  });

}
